import React from 'react';
import QuadArt from './QuadArt';


function port() {
  return (
    
    <section className="portfolio">
        <div className="container">
            <div className="row">
                <div className="col-sm-12 col-12">
                    <h3>Portfolios</h3>
                </div>
            </div>
        </div> 
        <hr />
        <div className="container-fluid">
            <div className="row" data-aos="fade-up" data-aos-delay="300">
            
                <QuadArt pagina="/Produciones_Art" text1="Artigos" img="/images/portfolio-2.jpg" />

                <QuadArt pagina="/Software" text1="Softwares" text2="Registrados" img="/images/portfolio-3.jpg" />

                <QuadArt pagina="/Projetos" text1="Projetos" img="/images/portfolio-4.jpg" />

                <QuadArt pagina="/Dissertacoes" text1="Dissertações"  img="/images/portfolio-5.jpg" />
              
            </div>
            <div className="row" data-aos="fade-up" data-aos-delay="300">
                
                <QuadArt pagina="/Teses" text1="Teses" img="/images/portfolio-10.jpg" />

                <QuadArt pagina="/Eventos" text1="Eventos" img="/images/portfolio-11.jpg" />

                <QuadArt pagina="/Portfolio" text1="Cursos" img="/images/portfolio-12.jpg" />

                <QuadArt pagina="/Portfolio" text1="Extensão"  img="/images/portfolio-13.png" />

            </div>
            
        </div>
    </section>
    
    
  );
}

export default port;